/* eslint-disable max-lines */
import { linkedUserPropType } from './prop-types/current-user/linked-user-prop-type'
import { multiAccountPropType } from './prop-types/current-user/multi-account-prop-type'
import { accelerationEventPropType } from './prop-types/vehicle/acceleration-event-prop-type'
import { accelerationEventTypePropType } from './prop-types/vehicle/acceleration-event-type-prop-type'
import { accelerationVehicleTypePropType } from './prop-types/vehicle/acceleration-vehicle-type-prop-type'
import { accountPropType } from './prop-types/current-user/account-prop-type'
import { accountDealerAccessPropType } from './prop-types/settings/account-dealer-access-prop-type'
import { activeCouplingsPropType } from './prop-types/vehicle/active-couplings-prop-type'
import { addressGroupPropType } from './prop-types/address/address-group-prop-type'
import { addressPropType } from './prop-types/address/address-prop-type'
import { areaDefinitionPropType } from './prop-types/areas/area-definition-prop-type'
import { areaPropType } from './prop-types/areas/area-prop-type'
import { areaSpeedProfilePropType } from './prop-types/areas/area-speed-profile-prop-type'
import { areaSchedulePropType } from './prop-types/areas/area-schedule-prop-type'
import { availableRdtRulePropType } from './prop-types/rdt/available-rdt-rule-prop-type'
import { availableRdtRuleRegulationOptionPropType } from './prop-types/rdt/available-rdt-rule-regulation-option-prop-type'
import { availableRdtRuleRegulationPropType } from './prop-types/rdt/available-rdt-rule-regulation-prop-type'
import { axleLoadEventPropType } from './prop-types/ebs/axle-load-event-prop-type'
import { batteryCurveEntryPropType } from './prop-types/electric/battery-curve-entry-prop-type'
import { bookableFeaturePropType } from './prop-types/selfservice/bookable-feature-prop-type'
import { bookedFeaturePropType } from './prop-types/selfservice/booked-feature-prop-type'
import { cameraEventPropType } from './prop-types/camera/camera-event-prop-type'
import { cameraIoSubscriptionPropType } from './prop-types/camera/camera-io-subscription'
import { cameraEventUserAccessPropType } from './prop-types/camera/camera-event-user-access-prop-type'
import { cameraPropType } from './prop-types/camera/camera-prop-type'
import { cameraTelemetryPropType } from './prop-types/camera/camera-telemetry-prop-type'
import { cameraViewPropType } from './prop-types/camera/camera-view-prop-type'
import { chargingStationConnectorTypePropType } from './prop-types/electric/charging-station-connector-type-prop-type'
import { checklistItemPropType } from './prop-types/checklists/checklist-item-prop-type'
import { checklistPropType } from './prop-types/checklists/checklist-prop-type'
import { coldChainApiConnectionPropType } from './prop-types/cold-chain/cold-chain-api-connection-prop-type'
import { coldChainApiConnectionStatusPropType } from './prop-types/cold-chain/cold-chain-api-connection-status-prop-type'
import { controlFlagsPropType } from './prop-types/common/control-flags-prop-type'
import { coolingDevicePropType } from './prop-types/cold-chain/cooling-device-prop-type'
import { countryPropType } from './prop-types/common/country-prop-type'
import { crashEventPropType } from './prop-types/crash-event/crash-event-prop-type'
import { crashLogPropType } from './prop-types/crash-log/crash-log-prop-type'
import { createDriverLitePropType } from './prop-types/drivers/create-driver-lite-prop-type'
import { cruiseControlEventPropType } from './prop-types/vehicle/cruise-control-event-prop-type'
import { currentDriverObjectAssignmentPropType } from './prop-types/drivers/current-driver-object-assignment-prop-type'
import { currentUserPropType } from './prop-types/current-user/current-user-prop-type'
import { currentWorkStatePropType } from './prop-types/drivers/current-work-state-prop-type'
import { workAppVehicleUsersPropType } from './prop-types/work-app-vehicle-users/work-app-vehicle-users-prop-type'
import { customerContactDepartmentPropType } from './prop-types/selfservice/customer-contact-department-prop-type'
import { customerContactPositionPropType } from './prop-types/selfservice/customer-contact-position-prop-type'
import { customerContactPropType } from './prop-types/selfservice/customer-contact-prop-type'
import { customerPropType } from './prop-types/selfservice/customer-prop-type'
import { dealerAccessLogEntryPropType } from './prop-types/settings/dealer-access-log-entry-prop-type'
import { dealerPropType } from './prop-types/selfservice/dealer-prop-type'
import { devicePropType } from './prop-types/selfservice/device-prop-type'
import { doorPropType } from './prop-types/cold-chain/door-prop-type'
import { doorStatusDataPropType } from './prop-types/cold-chain/door-status-data-prop-type'
import { doorStatusDataHistoryPropType } from './prop-types/cold-chain/door-status-data-history-prop-type'
import { driverControlFlagsPropType } from './prop-types/drivers/driver-control-flag-prop-type'
import { driverGroupDriversPropType } from './prop-types/drivers/driver-group-drivers-prop-type'
import { driverGroupPropType } from './prop-types/drivers/driver-group-prop-type'
import { driverKeyPropType } from './prop-types/drivers/driver-key-prop-type'
import { driverKeyTypePropType } from './prop-types/drivers/driver-key-type-prop-type'
import { driverKpiPropType } from './prop-types/drivers/driver-kpi-prop-type'
import { driverPropType } from './prop-types/drivers/driver-prop-type'
import { driverRdtRulePropType } from './prop-types/rdt/driver-rdt-rule-prop-type'
import { driversInDriverGroupsPropType } from './prop-types/drivers/drivers-in-driver-groups'
import { driverTerminalMapsPropType } from './prop-types/vehicle/driver-terminal-maps-prop-type'
import { durationRestPropType } from './prop-types/drivers/duration-rest-prop-type'
import { electricAccountSettingsPropType } from './prop-types/electric/electric-account-settings-prop-type'
import { electricNotificationsAccountConfigPropType } from './prop-types/electric/electric-notifications-account-configuration-prop-type'
import { electricNotificationsBatteryLevelBasedConfigPropType } from './prop-types/electric/electric-notifications-battery-level-based-prop-type'
import { electricNotificationsChargingFailedConfigPropType } from './prop-types/electric/electric-notifications-charging-failed-prop-type'
import { electricNotificationsVehicleConfigPropType } from './prop-types/electric/electric-notifications-vehicle-configuration-prop-type'
import { electricUserSettingsPropType } from './prop-types/electric/electric-user-settings-prop-type'
import { electricVehicleBatteryCapacityOptionsPropType } from './prop-types/electric/electric-vehicle-battery-capacity-options-prop-type'
import { electricVehicleBatteryInsightPropType } from './prop-types/electric/electric-vehicle-battery-insight-prop-type'
import { electricVehicleSettingsPropType } from './prop-types/electric/electric-vehicle-settings-prop-type'
import { electricVehicleBatteryCurveProfilePropType } from './prop-types/electric/electric-vehicle-battery-curve-profile-prop-type'
import { electricVehicleEnergyConsumptionProfilePropType } from './prop-types/electric/electric-vehicle-energy-consumption-profile-prop-type'
import { electricVehicleStatePropType } from './prop-types/electric/electric-vehicle-state-prop-type'
import { electrifiableVehicleStatePropType } from './prop-types/electric/electrifiable-vehicle-state-prop-type'
import { energyConsumptionForSpeedPropType } from './prop-types/electric/energy-consumption-for-speed-prop-type'
import { energyConsumptionPreferencePropType } from './prop-types/vehicle/energy-consumption-preference-prop-type'
import { erucMatchPropType } from './prop-types/eruc-data/eruc-match-prop-type'
import { externalDataPropType } from './prop-types/vehicle/external-data-prop-type'
import { externalDataSharingOptionsPropType } from './prop-types/selfservice/external-data-sharing-options-prop-type'
import { externalDataSharingPropType } from './prop-types/selfservice/external-data-sharing-prop-type'
import { externalLinkPropType } from './prop-types/vehicle/external-link-prop-type'
import { externalObjectDataPropType } from './prop-types/vehicle/external-object-data-prop-type'
import { federalStatePropType } from './prop-types/common/federal-state-prop-type'
import { fuelLevelEventPropType } from './prop-types/vehicle/fuel-level-event-prop-type'
import { fuelTypePropType } from './prop-types/vehicle/fuel-type-prop-type'
import { globalControlFlagsPropType } from './prop-types/common/global-control-flags-prop-type'
import { grantedRightLevelListPropType } from './prop-types/users/granted-right-level-list-prop-type'
import { grantedRightLevelPropType } from './prop-types/users/granted-right-level-prop-type'
import { idlingPropType } from './prop-types/vehicle/idling-prop-type'
import { idPropType } from './prop-types/common/id-prop-type'
import { inputOutputEventPropType } from './prop-types/vehicle/input-output-event-prop-type'
import { intervalPropType } from './prop-types/common/interval-prop-type'
import { invoiceNotificationDeliveryTypePropType } from './prop-types/selfservice/invoice-notification-delivery-type-prop-type'
import { invoiceNotificationEmailAddressPropType } from './prop-types/selfservice/invoice-notification-email-prop-type'
import { invoiceNotificationOptionPropType } from './prop-types/selfservice/invoice-notification-option-prop-type'
import { iso8601DurationPropType } from './prop-types/common/iso-8601-duration-prop-type'
import { iso8601PropType } from './prop-types/common/iso-8601-prop-type'
import { locationDescriptionPropType } from './prop-types/common/location-description-prop-type'
import { locationDescriptionBasePropType } from './prop-types/cold-chain/location-description-base-prop-type'
import { logbook7DaysRulePropType } from './prop-types/logbook/logbook-seven-days-rule-prop-type'
import { logbookEntryPropType } from './prop-types/logbook/logbook-entry-prop-type'
import { logbookModePropType } from './prop-types/logbook/logbook-mode-prop-type'
import { logbookPrivateUseModePropType } from './prop-types/logbook/logbook-private-use-mode-prop-type'
import { logbookPrivateUseModesConfigurationPropType } from './prop-types/logbook/logbook-private-use-modes-configuration-prop-type'
import { objectAvailabilitiesPropType } from './prop-types/vehicle/object-availabilities-prop-type'
import { notificationPropType } from './prop-types/notifications/notification-prop-type'
import { objectActivityPropType } from './prop-types/vehicle/object-activity-prop-type'
import { objectAvailabilityDetailsPropType } from './prop-types/vehicle/object-availability-details-prop-type'
import { objectAvailabilityPropType } from './prop-types/vehicle/object-availability-prop-type'
import { objectAvailabilityStatusPropType } from './prop-types/vehicle/object-availability-status-prop-type'
import { objectClassPropType } from './prop-types/vehicle/object-class-prop-type'
import { objectColorPropType } from './prop-types/vehicle/object-color-prop-type'
import { objectControlFlagPropType } from './prop-types/vehicle/object-control-flag-prop-type'
import { objectCoolingDevicePropType } from './prop-types/cold-chain/object-cooling-device-prop-type'
import { objectEbsStatePropType } from './prop-types/ebs/object-ebs-state-prop-type'
import { objectEbsStateEventPropType } from './prop-types/ebs/object-ebs-state-event-prop-type'
import { objectEventPropType } from './prop-types/notifications/object-event-prop-type'
import { objectFeatureQuotaPropType } from './prop-types/vehicle/object-feature-quota-prop-type'
import { objectFuelUsagePropType } from './prop-types/vehicle/object-fuel-usage-prop-type'
import { objectGroupObjectsPropType } from './prop-types/vehicle/object-group-objects-prop-type'
import { objectGroupPropType } from './prop-types/vehicle/object-group-prop-type'
import { objectGroupsPropType } from './prop-types/vehicle/object-groups-prop-type'
import { objectImmobilizerPropType } from './prop-types/vehicle/object-immobilizer-prop-type'
import { objectImmobilizerStatePropType } from './prop-types/vehicle/object-immobilizer-state-prop-type'
import { objectMessagePropType } from './prop-types/vehicle/object-message-prop-type'
import { objectMotionDetectionPropType } from './prop-types/vehicle/object-motion-detection-prop-type'
import { objectPrivateUseModesPropType } from './prop-types/logbook/object-logbook-privacy-prop-type'
import { objectRecurringCustomerBookingPropType } from './prop-types/vehicle/object-recurring-customer-booking-prop-type'
import { objectTextMessageDirectionPropType } from './prop-types/vehicle/object-text-message-direction-prop-type'
import { objectTextMessagePropType } from './prop-types/vehicle/object-text-message-prop-type'
import { objectTextMessageStatsPropType } from './prop-types/vehicle/object-text-message-stats-prop-type'
import { objectTextMessageStatusPropType } from './prop-types/vehicle/object-text-message-status-prop-type'
import { objectTypePropType } from './prop-types/vehicle/object-type-prop-type'
import { optiDriveEventExclusionPropType } from './prop-types/opti-drive/opti-drive-event-exclusion-prop-type'
import { optiDriveKpiTypePropType } from './prop-types/drivers/opti-drive-kpi-type-prop-type'
import { optiDriveProfilePropType } from './prop-types/opti-drive/opti-drive-profile-prop-type'
import { orderAddressPropType } from './prop-types/orders/order-address-prop-type'
import { orderContactPropType } from './prop-types/orders/order-contact-prop-type'
import { orderMessageLocationPropType } from './prop-types/orders/order-message-location-prop-type'
import { orderMessagePropType } from './prop-types/orders/order-message-prop-type'
import { orderPropType } from './prop-types/orders/order-prop-type'
import { orderRelationPropType } from './prop-types/orders/order-relation-prop-type'
import { orderTemplatePropType } from './prop-types/orders/order-template-prop-type'
import { orderTourPropType } from './prop-types/order-tour/order-tour-prop-types'
import { orderTourTemplatePropType } from './prop-types/order-tour/order-tour-template-prop-type'
import { positionPropType } from './prop-types/common/position-prop-type'
import { publicIncidentComponentPropType } from './prop-types/public-incidents/public-incident-component-prop-type'
import { publicIncidentPropType } from './prop-types/public-incidents/public-incident-prop-type'
import { rdtDailyActivitiesPropType } from './prop-types/rdt/rdt-daily-activities-prop-type'
import { rdtDailyWorkingPropType } from './prop-types/rdt/rdt-daily-working-prop-type'
import { rdtDriverInfringementPropType } from './prop-types/rdt/rdt-driver-infringement-prop-type'
import { rdtDurationPropType } from './prop-types/rdt/rdt-duration-prop-type'
import { rdtInfringementLevelPropType } from './prop-types/rdt/rdt-infringement-level-prop-type'
import { rdtInfringementPropType } from './prop-types/rdt/rdt-infringement-prop-type'
import { rdtWarningLevelPropType } from './prop-types/rdt/rdt-warning-level-prop-type'
import { rdtWeeklyWorkingPropType } from './prop-types/rdt/rdt-weekly-working-prop-type'
import { reducedWeeklyRestPeriodCompensationRestPropType } from './prop-types/drivers/reduced-weekly-rest-period-compensation-rest-prop-type'
import { remainingDrivingTimePropType } from './prop-types/rdt/remaining-driving-time-prop-type'
import { rightLevelPropType } from './prop-types/users/right-level-prop-type'
import { rightProfilePropType } from './prop-types/users/right-profile-prop-type'
import { routeParametersPropType } from './prop-types/route/route-parameters-prop-type'
import { routePropType } from './prop-types/route/route-prop-type'
import { satelliteDataConsumptionPropType } from './prop-types/vehicle/satellite-data-consumption-prop-type'
import { settingsPropType } from './prop-types/settings/settings-prop-type'
import { speedingEventPropType } from './prop-types/vehicle/speeding-event-prop-type'
import { standstillPropType } from './prop-types/vehicle/standstill-prop-type'
import { subscriptionPropType } from './prop-types/selfservice/subscription-prop-type'
import { tachographCardPropType } from './prop-types/drivers/tachograph-card-prop-type'
import { tachographTypePropType } from './prop-types/vehicle/tachograph-types-prop-type'
import { telematicDeviceAccessoryPropType } from './prop-types/vehicle/telematic-device-accessory-prop-type'
import { temperatureDataPropType } from './prop-types/cold-chain/temperature-data-prop-type'
import { temperatureSensorConfigPropType } from './prop-types/cold-chain/temperature-sensor-config-prop-type'
import { temperatureSensorPropType } from './prop-types/cold-chain/temperature-sensor-prop-type'
import { temperatureSensorDataHistoryPropType } from './prop-types/cold-chain/temperature-sensor-data-history-prop-type'
import { textMessageCommunicatorPropType } from './prop-types/message/text-message-communicator-prop-type'
import { textMessagePropType } from './prop-types/message/text-message-prop-type'
import { thirdPartyServicePropType } from './prop-types/common/third-party-service-prop-type'
import { tpmsAlarmConfigurationPropType } from './prop-types/tpms/tpms-alarm-configuration-prop-type'
import { tpmsAxlePropType } from './prop-types/tpms/tpms-axle-prop-type'
import { tpmsChassisPropType } from './prop-types/tpms/tpms-chassis-prop-type'
import { tpmsMeasurementPropType } from './prop-types/tpms/tpms-measurement-prop-type'
import { tpmsSensorLocationPropType } from './prop-types/tpms/tpms-sensor-location-prop-type'
import { tpmsSensorMeasurementsPropType } from './prop-types/tpms/tpms-sensor-measurements-prop-type'
import { tpmsSensorPropType } from './prop-types/tpms/tpms-sensor-prop-type'
import { tpmsTireLocationPropType } from './prop-types/tpms/tpms-tire-location-prop-type'
import { tpmsTirePropType } from './prop-types/tpms/tpms-tire-prop-type'
import { tpmsTireIssuePropType } from './prop-types/tpms/tpms-tire-issue-prop-type'
import { tpmsSensorStatePropType } from './prop-types/tpms/tpms-sensor-state-prop-type'
import { tpmsTireBrandPropType } from './prop-types/tpms/tpms-tire-brand-prop-type'
import { tpmsTireModelPropType } from './prop-types/tpms/tpms-tire-model-prop-type'
import { tpmsTireProducerPropType } from './prop-types/tpms/tpms-tire-producer-prop-type'
import { tpmsTireSizePropType } from './prop-types/tpms/tpms-tire-size-prop-type'
import { trackDataPropType } from './prop-types/track-data/track-data-prop-type'
import { trackPropType } from './prop-types/track/track-prop-type'
import { translationPropType } from './prop-types/common/translation-prop-type'
import { tripModePropType } from './prop-types/trip/trip-mode-prop-type'
import { tripPropType } from './prop-types/trip/trip-prop-type'
import { uiFeatureLimitPropType } from './prop-types/common/ui-feature-limit-prop-type'
import { userPropType } from './prop-types/users/user-prop-type'
import { vehicleDiagnosticEventPropType } from './prop-types/vehicle-diagnostic-event/vehicle-diagnostic-event-prop-type'
import { vehicleGenerationPropType } from './prop-types/vehicle/vehicle-generation-prop-type'
import { vehicleImagePropType } from './prop-types/vehicle/vehicle-image-prop-type'
import { vehicleImagesPropType } from './prop-types/vehicle/vehicle-images-prop-type'
import { vehicleMaintenanceTaskCompletionReasonPropType } from './prop-types/maintenance/vehicle-maintenance-task-completion-reason-prop-type'
import { vehicleMakePropType } from './prop-types/vehicle/vehicle-make-prop-type'
import { vehicleModelPropType } from './prop-types/vehicle/vehicle-model-prop-type'
import { vehicleObjectDetailsPropType } from './prop-types/vehicle/vehicle-object-details-prop-type'
import { vehicleObjectPropType } from './prop-types/vehicle/vehicle-object-prop-type'
import { vehicleTpmsIssuesPropType } from './prop-types/vehicle/vehicle-tpms-issues-prop-type'
import { vehicleUsageTypePropType } from './prop-types/vehicle/vehicle-usage-type-prop-type'
import { webfleetAccessTokenPropType } from './prop-types/common/webfleet-access-token-prop-type'
import { workingTimePropType } from './prop-types/drivers/working-time-prop-type'
import { workingTimesActivityEditPropType } from './prop-types/drivers/working-times-activity-edit-prop-type'
import { workStatePropType } from './prop-types/drivers/work-state-prop-type'
import { applicationPropType } from './prop-types/applications/application-prop-type'
import { applicationGroupPropType } from './prop-types/applications/application-group-prop-type'
import { userRightLevelsPropType } from './prop-types/users/user-right-levels-prop-type'
import { customCouplingRulePropType } from './prop-types/vehicle/custom-coupling-rule-prop-type'
import { temperatureViolationPropType } from './prop-types/cold-chain/temperature-violation-prop-type'
import { accountDataSharingsPropType } from './prop-types/business-entities/account-data-sharings-prop-type'
import { validErucAccountPropType } from './prop-types/eruc-data/valid-eruc-account-prop-type'
import { orderDocumentPropType } from './prop-types/orders/order-document-prop-type'
import { sharedOrderStatusLinkPropType } from './prop-types/shared-order-status-link/shared-order-status-links-prop-type'
import { cameraEventCommentPropType } from './prop-types/camera/camera-event-comment-prop-type'
import { vehicleSpecificationBrandPropType } from './prop-types/vehicle-specification-management/vehicle-specification-brand-prop-type'
import { vehicleSpecificationModelPropType } from './prop-types/vehicle-specification-management/vehicle-specification-model-prop-type'
import { objectEbsSettingsPropType } from './prop-types/ebs/object-ebs-settings-prop-type'
import { cameraOverviewPropType } from './prop-types/camera/camera-overview-prop-type'
import { brakePerformancePropType } from './prop-types/ebs/brake-performance-prop-type'
import { stpParkingProvidersPropType } from './prop-types/secure-truck-parking/stp-parking-providers'
import {
    dataSharingOptionPropType,
    dataSharingApplicationPropType
} from './prop-types/business-entities/data-sharing-applications-prop-type'
import { stpParkingPropType } from './prop-types/secure-truck-parking/stp-parking'
import {
    stpParkingInformationFeaturePropType,
    stpParkingInformationPropType
} from './prop-types/secure-truck-parking/stp-parking-information'
import { stpParkingPricePropType } from './prop-types/secure-truck-parking/stp-parking-price'
import { stpParkingBookingsPropType } from './prop-types/secure-truck-parking/stp-parking-bookings'
import { inboxMessagePropType } from './prop-types/inbox-message/inbox-message-prop-type'
import { inboxMessageAttributePropType } from './prop-types/inbox-message/inbox-message-attribute-prop-type'

// Please remove the "PropType" postfix, because we don't need it.
// (consider "RestPropTypes.driver" vs "RestPropTypes.driverPropType")

/**
 * @type {Object}
 */
export const RestPropTypes = {
    accelerationEvent: accelerationEventPropType,
    accelerationEventType: accelerationEventTypePropType,
    accelerationVehicleType: accelerationVehicleTypePropType,
    account: accountPropType,
    accountDealerAccess: accountDealerAccessPropType,
    activeCouplings: activeCouplingsPropType,
    address: addressPropType,
    addressGroup: addressGroupPropType,
    application: applicationPropType,
    applicationGroup: applicationGroupPropType,
    area: areaPropType,
    areaDefinition: areaDefinitionPropType,
    areaSpeedProfile: areaSpeedProfilePropType,
    areaSchedule: areaSchedulePropType,
    availableRdtRule: availableRdtRulePropType,
    availableRdtRuleRegulation: availableRdtRuleRegulationPropType,
    availableRdtRuleRegulationOption: availableRdtRuleRegulationOptionPropType,
    axleLoadEvent: axleLoadEventPropType,
    batteryCurveEntry: batteryCurveEntryPropType,
    bookableFeature: bookableFeaturePropType,
    bookedFeature: bookedFeaturePropType,
    brakePerformance: brakePerformancePropType,
    camera: cameraPropType,
    cameraEvent: cameraEventPropType,
    cameraIoSubscription: cameraIoSubscriptionPropType,
    cameraEventComment: cameraEventCommentPropType,
    cameraEventUserAccess: cameraEventUserAccessPropType,
    cameraOverview: cameraOverviewPropType,
    cameraView: cameraViewPropType,
    cameraTelemetry: cameraTelemetryPropType,
    chargingStationConnectorType: chargingStationConnectorTypePropType,
    checklist: checklistPropType,
    checklistItem: checklistItemPropType,
    coldChainApiConnection: coldChainApiConnectionPropType,
    coldChainApiConnectionStatus: coldChainApiConnectionStatusPropType,
    controlFlags: controlFlagsPropType,
    coolingDevices: coolingDevicePropType,
    country: countryPropType,
    crashEvent: crashEventPropType,
    crashLog: crashLogPropType,
    createDriverLite: createDriverLitePropType,
    cruiseControlEvent: cruiseControlEventPropType,
    currentDriverObjectAssignment: currentDriverObjectAssignmentPropType,
    currentUser: currentUserPropType,
    currentWorkState: currentWorkStatePropType,
    customCouplingRule: customCouplingRulePropType,
    customCouplingRuleType: customCouplingRulePropType,
    customer: customerPropType,
    customerContact: customerContactPropType,
    customerContactDepartment: customerContactDepartmentPropType,
    customerContactPosition: customerContactPositionPropType,
    dataSharingApplication: dataSharingApplicationPropType,
    dataSharingOption: dataSharingOptionPropType,
    dealer: dealerPropType,
    dealerAccessLogEntry: dealerAccessLogEntryPropType,
    device: devicePropType,
    door: doorPropType,
    doorStatusData: doorStatusDataPropType,
    doorStatusDataHistory: doorStatusDataHistoryPropType,
    driver: driverPropType,
    driverControlFlags: driverControlFlagsPropType,
    driverGroup: driverGroupPropType,
    driverGroupDrivers: driverGroupDriversPropType,
    driverKey: driverKeyPropType,
    driverKeyType: driverKeyTypePropType,
    driverKpi: driverKpiPropType,
    driverRdtRule: driverRdtRulePropType,
    driverTerminalMaps: driverTerminalMapsPropType,
    driversInDriverGroups: driversInDriverGroupsPropType,
    durationRest: durationRestPropType,
    electricAccountSettings: electricAccountSettingsPropType,
    electricNotificationsAccountConfig: electricNotificationsAccountConfigPropType,
    electricNotificationsChargingFailedConfig: electricNotificationsChargingFailedConfigPropType,
    electricNotificationsChargingFinishedConfig: electricNotificationsBatteryLevelBasedConfigPropType,
    electricNotificationsVehicleConfig: electricNotificationsVehicleConfigPropType,
    electricUserSettings: electricUserSettingsPropType,
    electricVehicleBatteryCapacityOptions: electricVehicleBatteryCapacityOptionsPropType,
    electricVehicleBatteryCurveProfile: electricVehicleBatteryCurveProfilePropType,
    electricVehicleBatteryInsight: electricVehicleBatteryInsightPropType,
    electricVehicleEnergyConsumptionProfile: electricVehicleEnergyConsumptionProfilePropType,
    electricVehicleSettings: electricVehicleSettingsPropType,
    electricVehicleState: electricVehicleStatePropType,
    electrifiableVehicleState: electrifiableVehicleStatePropType,
    energyConsumptionForSpeed: energyConsumptionForSpeedPropType,
    energyConsumptionPreference: energyConsumptionPreferencePropType,
    externalData: externalDataPropType,
    externalDataSharing: externalDataSharingPropType,
    externalDataSharingOptions: externalDataSharingOptionsPropType,
    externalLink: externalLinkPropType,
    externalObjectData: externalObjectDataPropType,
    federalState: federalStatePropType,
    fuelLevelEvent: fuelLevelEventPropType,
    fuelType: fuelTypePropType,
    globalControlFlags: globalControlFlagsPropType,
    grantedRightLevel: grantedRightLevelPropType,
    grantedRightLevelList: grantedRightLevelListPropType,
    id: idPropType,
    idling: idlingPropType,
    inboxMessage: inboxMessagePropType,
    inboxMessageAttribute: inboxMessageAttributePropType,
    inputOutputEvent: inputOutputEventPropType,
    interval: intervalPropType,
    invoiceNotificationDeliveryType: invoiceNotificationDeliveryTypePropType,
    invoiceNotificationEmailAddress: invoiceNotificationEmailAddressPropType,
    invoiceNotificationOption: invoiceNotificationOptionPropType,
    iso8601: iso8601PropType,
    iso8601Duration: iso8601DurationPropType,
    linkedUser: linkedUserPropType,
    locationDescription: locationDescriptionPropType,
    locationDescriptionBase: locationDescriptionBasePropType,
    logbook7DaysRule: logbook7DaysRulePropType,
    logbookEntry: logbookEntryPropType,
    logbookMode: logbookModePropType,
    logbookPrivateUseMode: logbookPrivateUseModePropType,
    logbookPrivateUseModesConfiguration: logbookPrivateUseModesConfigurationPropType,
    multiAccount: multiAccountPropType,
    notification: notificationPropType,
    objectActivity: objectActivityPropType,
    objectAvailabilities: objectAvailabilitiesPropType,
    objectAvailability: objectAvailabilityPropType,
    objectAvailabilityDetails: objectAvailabilityDetailsPropType,
    objectAvailabilityStatus: objectAvailabilityStatusPropType,
    objectClass: objectClassPropType,
    objectColor: objectColorPropType,
    objectControlFlags: objectControlFlagPropType,
    objectCoolingDevice: objectCoolingDevicePropType,
    objectEbsSettings: objectEbsSettingsPropType,
    objectEbsState: objectEbsStatePropType,
    objectEbsStateEvent: objectEbsStateEventPropType,
    objectEvent: objectEventPropType,
    objectFeatureQuota: objectFeatureQuotaPropType,
    objectFuelUsage: objectFuelUsagePropType,
    objectGroup: objectGroupPropType,
    objectGroupObjects: objectGroupObjectsPropType,
    objectGroups: objectGroupsPropType,
    objectImmobilizer: objectImmobilizerPropType,
    objectImmobilizerState: objectImmobilizerStatePropType,
    objectMessage: objectMessagePropType,
    objectMotionDetection: objectMotionDetectionPropType,
    objectPrivateUseModes: objectPrivateUseModesPropType,
    objectRecurringCustomerBooking: objectRecurringCustomerBookingPropType,
    objectTextMessage: objectTextMessagePropType,
    objectTextMessageDirection: objectTextMessageDirectionPropType,
    objectTextMessageStats: objectTextMessageStatsPropType,
    objectTextMessageStatus: objectTextMessageStatusPropType,
    objectType: objectTypePropType,
    optiDriveEventExclusion: optiDriveEventExclusionPropType,
    optiDriveKpiType: optiDriveKpiTypePropType,
    optiDriveProfile: optiDriveProfilePropType,
    order: orderPropType,
    orderAddress: orderAddressPropType,
    orderContact: orderContactPropType,
    orderDocument: orderDocumentPropType,
    orderMessage: orderMessagePropType,
    orderMessageLocation: orderMessageLocationPropType,
    orderRelation: orderRelationPropType,
    orderTemplate: orderTemplatePropType,
    orderTour: orderTourPropType,
    orderTourTemplate: orderTourTemplatePropType,
    position: positionPropType,
    publicIncidentComponent: publicIncidentComponentPropType,
    publicIncident: publicIncidentPropType,
    rdtDailyActivities: rdtDailyActivitiesPropType,
    rdtDailyWorking: rdtDailyWorkingPropType,
    rdtDriverInfringement: rdtDriverInfringementPropType,
    rdtDuration: rdtDurationPropType,
    rdtInfringement: rdtInfringementPropType,
    rdtInfringementLevel: rdtInfringementLevelPropType,
    rdtWarningLevel: rdtWarningLevelPropType,
    rdtWeeklyWorking: rdtWeeklyWorkingPropType,
    reducedWeeklyRestPeriodCompensationRest: reducedWeeklyRestPeriodCompensationRestPropType,
    remainingDrivingTime: remainingDrivingTimePropType,
    rightLevel: rightLevelPropType,
    rightProfile: rightProfilePropType,
    route: routePropType,
    routeParameters: routeParametersPropType,
    satelliteDataConsumption: satelliteDataConsumptionPropType,
    settings: settingsPropType,
    sharedOrderStatusLink: sharedOrderStatusLinkPropType,
    speeding: speedingEventPropType,
    standstill: standstillPropType,
    stpGetParkingProviders: stpParkingProvidersPropType,
    stpParkingBookings: stpParkingBookingsPropType,
    stpParkingInformationFeature: stpParkingInformationFeaturePropType,
    stpParkingInformation: stpParkingInformationPropType,
    stpParkingPrice: stpParkingPricePropType,
    stpParkings: stpParkingPropType,
    subscription: subscriptionPropType,
    tachographCard: tachographCardPropType,
    tachographType: tachographTypePropType,
    telematicDeviceAccessory: telematicDeviceAccessoryPropType,
    temperatureData: temperatureDataPropType,
    temperatureSensorConfig: temperatureSensorConfigPropType,
    temperatureSensor: temperatureSensorPropType,
    temperatureSensorDataHistory: temperatureSensorDataHistoryPropType,
    temperatureViolation: temperatureViolationPropType,
    textMessage: textMessagePropType,
    textMessageCommunicator: textMessageCommunicatorPropType,
    thirdPartyService: thirdPartyServicePropType,
    tpmsAlarmConfiguration: tpmsAlarmConfigurationPropType,
    tpmsAxle: tpmsAxlePropType,
    tpmsChassis: tpmsChassisPropType,
    tpmsMeasurement: tpmsMeasurementPropType,
    tpmsSensorLocation: tpmsSensorLocationPropType,
    tpmsSensorMeasurements: tpmsSensorMeasurementsPropType,
    tpmsSensor: tpmsSensorPropType,
    tpmsSensorState: tpmsSensorStatePropType,
    tpmsTire: tpmsTirePropType,
    tpmsTireIssue: tpmsTireIssuePropType,
    tpmsTireLocation: tpmsTireLocationPropType,
    tpmsTireBrand: tpmsTireBrandPropType,
    tpmsTireModel: tpmsTireModelPropType,
    tpmsTireProducer: tpmsTireProducerPropType,
    tpmsTireSize: tpmsTireSizePropType,
    track: trackPropType,
    trackData: trackDataPropType,
    translation: translationPropType,
    trip: tripPropType,
    tripMode: tripModePropType,
    uiFeatureLimit: uiFeatureLimitPropType,
    user: userPropType,
    userRightLevels: userRightLevelsPropType,
    vehicleDiagnosticEvent: vehicleDiagnosticEventPropType,
    vehicleGeneration: vehicleGenerationPropType,
    vehicleImage: vehicleImagePropType,
    vehicleImages: vehicleImagesPropType,
    vehicleMaintenanceTaskCompletionReason: vehicleMaintenanceTaskCompletionReasonPropType,
    vehicleMake: vehicleMakePropType,
    vehicleModel: vehicleModelPropType,
    vehicleObject: vehicleObjectPropType,
    vehicleObjectDetails: vehicleObjectDetailsPropType,
    vehicleTpmsIssues: vehicleTpmsIssuesPropType,
    vehicleUsageType: vehicleUsageTypePropType,
    viewTpmsData: controlFlagsPropType,
    webfleetAccessToken: webfleetAccessTokenPropType,
    workAppVehicleUsers: workAppVehicleUsersPropType,
    workState: workStatePropType,
    workingTime: workingTimePropType,
    workingTimesActivityEdit: workingTimesActivityEditPropType,
    accountDataSharings: accountDataSharingsPropType,
    validErucAccount: validErucAccountPropType,
    erucMatch: erucMatchPropType,
    vehicleSpecificationBrand: vehicleSpecificationBrandPropType,
    vehicleSpecificationModel: vehicleSpecificationModelPropType
}
